// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../styles/fonts/icons.eot?z4jeba", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../styles/fonts/icons.ttf?z4jeba", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../styles/fonts/icons.woff?z4jeba", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../styles/fonts/icons.svg?z4jeba", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icons" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-------------------------------------------------------------
	Icons
-------------------------------------------------------------*/
@font-face {
    font-family: 'icomoon';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
    font-weight: normal;
    font-style: normal;
}

.pull-right {
    float: right
}

.pull-left {
    float: left
}

[class^="icon-"], [class*=" icon-"],
[class^="ri-"], [class*=" ri-"],
.icon-any {
    speak: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: middle;
    display: inline-block;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

[class^="icon-"], [class*=" icon-"], .icon-any {
    font-weight: normal;
}

[class^="icon-"]:not([class^="ri-"]):not([class*=" ri-"]),
[class*=" icon-"]:not([class^="ri-"]):not([class*=" ri-"]),
.icon-any:not([class^="ri-"]):not([class*=" ri-"]) {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon', sans-serif !important;
}

.remixicon {
  font-family: 'remixicon', sans-serif !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-graphql:before {
  content: "\\e963";
}

.icon-arrow-up-off:before {
    content: "\\e948";
}

.icon-collapse:before {
    content: "\\e949";
}

.icon-eye-off:before {
    content: "\\e94a";
}

.icon-expand:before {
    content: "\\e94c";
}

/*.icon-focus:before {*/
/*    content: "\\e94d";*/
/*}*/

/*.icon-rotate-left:before {*/
/*    content: "\\e94e";*/
/*}*/

/*.icon-rotate-right:before {*/
/*    content: "\\e94f";*/
/*}*/

.icon-info-alt:before {
    content: "\\e950";
}

.icon-facebook:before {
    content: "\\e942";
}

.icon-google-plus:before {
    content: "\\e943";
}

.icon-google:before {
    content: "\\e944";
}

.icon-linkedin:before {
    content: "\\e945";
}

.icon-twitter:before {
    content: "\\e946";
}

.icon-youtube:before {
    content: "\\e947";
}

/*.icon-play:before {*/
/*    content: "\\e941";*/
/*}*/

.icon-email:before {
    content: "\\e93e";
}

.icon-sameas-on:before {
    content: "\\e93f";
}

.icon-sameas-off:before {
    content: "\\e940";
}

.icon-repo-contour1:before {
    content: "\\e906";
}

.icon-repo-contour2:before {
    content: "\\e90b";
}

.icon-repo-contour3:before {
    content: "\\e910";
}

/* Don't change the names of the repo icons, we rely on them being called master, worker, se, free, system */
.icon-repo-master-ro-mute:before {
    content: "\\e913";
}

.icon-repo-free:before {
    content: "\\e936";
}

.icon-repo-master-mute:before {
    content: "\\e937";
}

.icon-repo-master-ro:before {
    content: "\\e938";
}

.icon-repo-master:before {
    content: "\\e939";
}

.icon-repo-se:before {
    content: "\\e93a";
}

.icon-repo-system:before {
    content: "\\e93b";
}

.icon-repo-worker:before {
    content: "\\e93c";
}

.icon-repo:before {
    content: "\\e93d";
}

/*.icon-copy:before {*/
/*    content: "\\e934";*/
/*}*/

/*.icon-eye:before {*/
/*    content: "\\e935";*/
/*}*/

/*.icon-connection-off:before {*/
/*    content: "\\e931";*/
/*}*/

/*.icon-connection-on:before {*/
/*    content: "\\e932";*/
/*}*/

/*.icon-key:before {*/
/*    content: "\\e933";*/
/*}*/

/*.icon-comment:before {*/
/*    content: "\\e930";*/
/*}*/

.icon-arrow-down:before {
    content: "\\e900";
}

/*.icon-arrow-left:before {*/
/*    content: "\\e901";*/
/*}*/

/*.icon-arrow-right:before {*/
/*    content: "\\e902";*/
/*}*/

/*.icon-arrow-up:before {*/
/*    content: "\\e903";*/
/*}*/

/*.icon-exchange:before {*/
/*    content: "\\e904";*/
/*}*/

.icon-columns:before {
    content: "\\e905";
}

.icon-inferred-off:before {
    content: "\\e907";
}

.icon-inferred-on:before {
    content: "\\e908";
}

/*.icon-save:before {*/
/*    content: "\\e909";*/
/*}*/

/*.icon-tag:before {*/
/*    content: "\\e90a";*/
/*}*/

/*.icon-file:before {*/
/*    content: "\\e90c";*/
/*}*/

/*.icon-folder:before {*/
/*    content: "\\e90d";*/
/*}*/

.icon-heartbeat:before {
    content: "\\e90e";
}

/*.icon-pin:before {*/
/*    content: "\\e90f";*/
/*}*/

.icon-zoom-in:before {
    content: "\\e911";
}

/*.icon-zoom-out:before {*/
/*    content: "\\e912";*/
/*}*/

/*.icon-check:before {*/
/*    content: "\\e914";*/
/*}*/

/*.icon-download:before {*/
/*    content: "\\e915";*/
/*}*/

/*.icon-external:before {*/
/*    content: "\\e916";*/
/*}*/

.icon-lock:before {
    content: "\\e917";
}

/*.icon-search:before {*/
/*    content: "\\e918";*/
/*}*/

/*.icon-upload:before {*/
/*    content: "\\e919";*/
/*}*/

/*.icon-caret-left:before {*/
/*    content: "\\e91a";*/
/*}*/

/*.icon-caret-right:before {*/
/*    content: "\\e91b";*/
/*}*/

/*.icon-caret-up:before {*/
/*    content: "\\e91c";*/
/*}*/

/*.icon-minus:before {*/
/*    content: "\\e91d";*/
/*}*/

/*.icon-reload:before {*/
/*    content: "\\e91e";*/
/*}*/

/*.icon-trash:before {*/
/*    content: "\\e91f";*/
/*}*/

/*.icon-warning:before {*/
/*    content: "\\e920";*/
/*}*/

/*.icon-caret-down:before {*/
/*    content: "\\e921";*/
/*}*/

/*.icon-close:before {*/
/*    content: "\\e922";*/
/*}*/

/*.icon-edit:before {*/
/*    content: "\\e923";*/
/*}*/

/*.icon-info:before {*/
/*    content: "\\e924";*/
/*}*/

/*.icon-link:before {*/
/*    content: "\\e925";*/
/*}*/

.icon-more:before {
    content: "\\e926";
}

/*.icon-plus:before {*/
/*    content: "\\e927";*/
/*}*/

.icon-data:before {
    content: "\\e928";
}

/*.icon-help:before {*/
/*    content: "\\e929";*/
/*}*/

/*.icon-monitoring:before {*/
/*    content: "\\e92a";*/
/*}*/

/*.icon-settings:before {*/
/*    content: "\\e92b";*/
/*}*/

.icon-sparql:before {
    content: "\\e92c";
}

.icon-export-alt:before {
    content: "\\e92e";
}

/*.icon-import:before {*/
/*    content: "\\e92f";*/
/*}*/

.icon-hbars:before {
    content: "\\e953";
}

.icon-phone:before {
    content: "\\e954";
}

/*.icon-tick:before {*/
/*    content: "\\e956";*/
/*}*/

.icon-repo-ontop-alt:before {
    content: "\\e958";
}

.icon-repo-fedx-alt:before {
    content: "\\e959";
}

.icon-repo-graphdb-alt:before {
    content: "\\e95a";
}

/*.icon-export:before {*/
/*    content: "\\e95b";*/
/*}*/

.icon-readonly:before {
    content: "\\e95c";
}

.icon-repo-fedx:before {
    content: "\\e95d";
}

.icon-repo-graphdb:before {
    content: "\\e95e";
}

.icon-repo-ontop:before {
    content: "\\e95f";
}

.icon-repo-unknown:before {
    content: "\\e960";
}

/*.icon-translation:before {*/
/*    content: "\\e961";*/
/*}*/

.icon-follower:before {
    content: "\\e962";
}
/*.icon-exclamation:before {*/
/*    content: "\\e955";*/
/*}*/
/*
[class^="icon-"]:before, [class*=" icon-"]:before {
	display: inline-block;
}
*/

.icon-lg {
    font-size: 1.4em;
    line-height: 0.75em;
    /*    vertical-align: -15%;*/
}

.icon-1-25x, .btn .icon-1-25x[class^="icon-"] {
    font-size: 1.25em;
}

.icon-1-5x, .btn .icon-1-5x[class^="icon-"] {
    font-size: 1.5em;
}

.icon-2x, .btn .icon-2x[class^="icon-"] {
    font-size: 2em;
}

.icon-2-5x, .btn .icon-2-5x[class^="icon-"] {
    font-size: 2.5em;
}

.icon-3x, .btn .icon-3x[class^="icon-"] {
    font-size: 3em;
}

.icon-rotate-270:before {
    display: inline-block;
    -webkit-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
}

.icon-rotate-90:before {
    display: inline-block;
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
}
`, "",{"version":3,"sources":["webpack://./packages/root-config/src/vendor/icons.css"],"names":[],"mappings":"AAAA;;8DAE8D;AAC9D;IACI,sBAAsB;IACtB,4CAA4C;IAC5C;;;yDAG2D;IAC3D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;EAGE,+EAA+E;EAC/E,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB,wBAAwB;AACxB,IAAI;;AAEJ,6BAA6B;AAC7B,wBAAwB;AACxB,IAAI;;AAEJ,8BAA8B;AAC9B,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,4GAA4G;AAC5G;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ,qBAAqB;AACrB,wBAAwB;AACxB,IAAI;;AAEJ,gCAAgC;AAChC,wBAAwB;AACxB,IAAI;;AAEJ,+BAA+B;AAC/B,wBAAwB;AACxB,IAAI;;AAEJ,qBAAqB;AACrB,wBAAwB;AACxB,IAAI;;AAEJ,yBAAyB;AACzB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B,wBAAwB;AACxB,IAAI;;AAEJ,6BAA6B;AAC7B,wBAAwB;AACxB,IAAI;;AAEJ,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ,qBAAqB;AACrB,wBAAwB;AACxB,IAAI;;AAEJ,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ,wBAAwB;AACxB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ,uBAAuB;AACvB,wBAAwB;AACxB,IAAI;;AAEJ,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,IAAI;;AAEJ,wBAAwB;AACxB,wBAAwB;AACxB,IAAI;;AAEJ,4BAA4B;AAC5B,wBAAwB;AACxB,IAAI;;AAEJ,6BAA6B;AAC7B,wBAAwB;AACxB,IAAI;;AAEJ,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ,uBAAuB;AACvB,wBAAwB;AACxB,IAAI;;AAEJ,wBAAwB;AACxB,wBAAwB;AACxB,IAAI;;AAEJ,uBAAuB;AACvB,wBAAwB;AACxB,IAAI;;AAEJ,yBAAyB;AACzB,wBAAwB;AACxB,IAAI;;AAEJ,4BAA4B;AAC5B,wBAAwB;AACxB,IAAI;;AAEJ,uBAAuB;AACvB,wBAAwB;AACxB,IAAI;;AAEJ,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ,4BAA4B;AAC5B,wBAAwB;AACxB,IAAI;;AAEJ,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B,wBAAwB;AACxB,IAAI;;AAEJ;IACI,gBAAgB;AACpB;AACA,6BAA6B;AAC7B,wBAAwB;AACxB,IAAI;AACJ;;;;CAIC;;AAED;IACI,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;AAC7B","sourcesContent":["/*-------------------------------------------------------------\n\tIcons\n-------------------------------------------------------------*/\n@font-face {\n    font-family: 'icomoon';\n    src: url('../styles/fonts/icons.eot?z4jeba');\n    src: url('../styles/fonts/icons.eot?z4jeba#iefix') format('embedded-opentype'),\n    url('../styles/fonts/icons.ttf?z4jeba') format('truetype'),\n    url('../styles/fonts/icons.woff?z4jeba') format('woff'),\n    url('../styles/fonts/icons.svg?z4jeba#icons') format('svg');\n    font-weight: normal;\n    font-style: normal;\n}\n\n.pull-right {\n    float: right\n}\n\n.pull-left {\n    float: left\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"],\n[class^=\"ri-\"], [class*=\" ri-\"],\n.icon-any {\n    speak: none;\n    font-style: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    vertical-align: middle;\n    display: inline-block;\n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"], .icon-any {\n    font-weight: normal;\n}\n\n[class^=\"icon-\"]:not([class^=\"ri-\"]):not([class*=\" ri-\"]),\n[class*=\" icon-\"]:not([class^=\"ri-\"]):not([class*=\" ri-\"]),\n.icon-any:not([class^=\"ri-\"]):not([class*=\" ri-\"]) {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon', sans-serif !important;\n}\n\n.remixicon {\n  font-family: 'remixicon', sans-serif !important;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-graphql:before {\n  content: \"\\e963\";\n}\n\n.icon-arrow-up-off:before {\n    content: \"\\e948\";\n}\n\n.icon-collapse:before {\n    content: \"\\e949\";\n}\n\n.icon-eye-off:before {\n    content: \"\\e94a\";\n}\n\n.icon-expand:before {\n    content: \"\\e94c\";\n}\n\n/*.icon-focus:before {*/\n/*    content: \"\\e94d\";*/\n/*}*/\n\n/*.icon-rotate-left:before {*/\n/*    content: \"\\e94e\";*/\n/*}*/\n\n/*.icon-rotate-right:before {*/\n/*    content: \"\\e94f\";*/\n/*}*/\n\n.icon-info-alt:before {\n    content: \"\\e950\";\n}\n\n.icon-facebook:before {\n    content: \"\\e942\";\n}\n\n.icon-google-plus:before {\n    content: \"\\e943\";\n}\n\n.icon-google:before {\n    content: \"\\e944\";\n}\n\n.icon-linkedin:before {\n    content: \"\\e945\";\n}\n\n.icon-twitter:before {\n    content: \"\\e946\";\n}\n\n.icon-youtube:before {\n    content: \"\\e947\";\n}\n\n/*.icon-play:before {*/\n/*    content: \"\\e941\";*/\n/*}*/\n\n.icon-email:before {\n    content: \"\\e93e\";\n}\n\n.icon-sameas-on:before {\n    content: \"\\e93f\";\n}\n\n.icon-sameas-off:before {\n    content: \"\\e940\";\n}\n\n.icon-repo-contour1:before {\n    content: \"\\e906\";\n}\n\n.icon-repo-contour2:before {\n    content: \"\\e90b\";\n}\n\n.icon-repo-contour3:before {\n    content: \"\\e910\";\n}\n\n/* Don't change the names of the repo icons, we rely on them being called master, worker, se, free, system */\n.icon-repo-master-ro-mute:before {\n    content: \"\\e913\";\n}\n\n.icon-repo-free:before {\n    content: \"\\e936\";\n}\n\n.icon-repo-master-mute:before {\n    content: \"\\e937\";\n}\n\n.icon-repo-master-ro:before {\n    content: \"\\e938\";\n}\n\n.icon-repo-master:before {\n    content: \"\\e939\";\n}\n\n.icon-repo-se:before {\n    content: \"\\e93a\";\n}\n\n.icon-repo-system:before {\n    content: \"\\e93b\";\n}\n\n.icon-repo-worker:before {\n    content: \"\\e93c\";\n}\n\n.icon-repo:before {\n    content: \"\\e93d\";\n}\n\n/*.icon-copy:before {*/\n/*    content: \"\\e934\";*/\n/*}*/\n\n/*.icon-eye:before {*/\n/*    content: \"\\e935\";*/\n/*}*/\n\n/*.icon-connection-off:before {*/\n/*    content: \"\\e931\";*/\n/*}*/\n\n/*.icon-connection-on:before {*/\n/*    content: \"\\e932\";*/\n/*}*/\n\n/*.icon-key:before {*/\n/*    content: \"\\e933\";*/\n/*}*/\n\n/*.icon-comment:before {*/\n/*    content: \"\\e930\";*/\n/*}*/\n\n.icon-arrow-down:before {\n    content: \"\\e900\";\n}\n\n/*.icon-arrow-left:before {*/\n/*    content: \"\\e901\";*/\n/*}*/\n\n/*.icon-arrow-right:before {*/\n/*    content: \"\\e902\";*/\n/*}*/\n\n/*.icon-arrow-up:before {*/\n/*    content: \"\\e903\";*/\n/*}*/\n\n/*.icon-exchange:before {*/\n/*    content: \"\\e904\";*/\n/*}*/\n\n.icon-columns:before {\n    content: \"\\e905\";\n}\n\n.icon-inferred-off:before {\n    content: \"\\e907\";\n}\n\n.icon-inferred-on:before {\n    content: \"\\e908\";\n}\n\n/*.icon-save:before {*/\n/*    content: \"\\e909\";*/\n/*}*/\n\n/*.icon-tag:before {*/\n/*    content: \"\\e90a\";*/\n/*}*/\n\n/*.icon-file:before {*/\n/*    content: \"\\e90c\";*/\n/*}*/\n\n/*.icon-folder:before {*/\n/*    content: \"\\e90d\";*/\n/*}*/\n\n.icon-heartbeat:before {\n    content: \"\\e90e\";\n}\n\n/*.icon-pin:before {*/\n/*    content: \"\\e90f\";*/\n/*}*/\n\n.icon-zoom-in:before {\n    content: \"\\e911\";\n}\n\n/*.icon-zoom-out:before {*/\n/*    content: \"\\e912\";*/\n/*}*/\n\n/*.icon-check:before {*/\n/*    content: \"\\e914\";*/\n/*}*/\n\n/*.icon-download:before {*/\n/*    content: \"\\e915\";*/\n/*}*/\n\n/*.icon-external:before {*/\n/*    content: \"\\e916\";*/\n/*}*/\n\n.icon-lock:before {\n    content: \"\\e917\";\n}\n\n/*.icon-search:before {*/\n/*    content: \"\\e918\";*/\n/*}*/\n\n/*.icon-upload:before {*/\n/*    content: \"\\e919\";*/\n/*}*/\n\n/*.icon-caret-left:before {*/\n/*    content: \"\\e91a\";*/\n/*}*/\n\n/*.icon-caret-right:before {*/\n/*    content: \"\\e91b\";*/\n/*}*/\n\n/*.icon-caret-up:before {*/\n/*    content: \"\\e91c\";*/\n/*}*/\n\n/*.icon-minus:before {*/\n/*    content: \"\\e91d\";*/\n/*}*/\n\n/*.icon-reload:before {*/\n/*    content: \"\\e91e\";*/\n/*}*/\n\n/*.icon-trash:before {*/\n/*    content: \"\\e91f\";*/\n/*}*/\n\n/*.icon-warning:before {*/\n/*    content: \"\\e920\";*/\n/*}*/\n\n/*.icon-caret-down:before {*/\n/*    content: \"\\e921\";*/\n/*}*/\n\n/*.icon-close:before {*/\n/*    content: \"\\e922\";*/\n/*}*/\n\n/*.icon-edit:before {*/\n/*    content: \"\\e923\";*/\n/*}*/\n\n/*.icon-info:before {*/\n/*    content: \"\\e924\";*/\n/*}*/\n\n/*.icon-link:before {*/\n/*    content: \"\\e925\";*/\n/*}*/\n\n.icon-more:before {\n    content: \"\\e926\";\n}\n\n/*.icon-plus:before {*/\n/*    content: \"\\e927\";*/\n/*}*/\n\n.icon-data:before {\n    content: \"\\e928\";\n}\n\n/*.icon-help:before {*/\n/*    content: \"\\e929\";*/\n/*}*/\n\n/*.icon-monitoring:before {*/\n/*    content: \"\\e92a\";*/\n/*}*/\n\n/*.icon-settings:before {*/\n/*    content: \"\\e92b\";*/\n/*}*/\n\n.icon-sparql:before {\n    content: \"\\e92c\";\n}\n\n.icon-export-alt:before {\n    content: \"\\e92e\";\n}\n\n/*.icon-import:before {*/\n/*    content: \"\\e92f\";*/\n/*}*/\n\n.icon-hbars:before {\n    content: \"\\e953\";\n}\n\n.icon-phone:before {\n    content: \"\\e954\";\n}\n\n/*.icon-tick:before {*/\n/*    content: \"\\e956\";*/\n/*}*/\n\n.icon-repo-ontop-alt:before {\n    content: \"\\e958\";\n}\n\n.icon-repo-fedx-alt:before {\n    content: \"\\e959\";\n}\n\n.icon-repo-graphdb-alt:before {\n    content: \"\\e95a\";\n}\n\n/*.icon-export:before {*/\n/*    content: \"\\e95b\";*/\n/*}*/\n\n.icon-readonly:before {\n    content: \"\\e95c\";\n}\n\n.icon-repo-fedx:before {\n    content: \"\\e95d\";\n}\n\n.icon-repo-graphdb:before {\n    content: \"\\e95e\";\n}\n\n.icon-repo-ontop:before {\n    content: \"\\e95f\";\n}\n\n.icon-repo-unknown:before {\n    content: \"\\e960\";\n}\n\n/*.icon-translation:before {*/\n/*    content: \"\\e961\";*/\n/*}*/\n\n.icon-follower:before {\n    content: \"\\e962\";\n}\n/*.icon-exclamation:before {*/\n/*    content: \"\\e955\";*/\n/*}*/\n/*\n[class^=\"icon-\"]:before, [class*=\" icon-\"]:before {\n\tdisplay: inline-block;\n}\n*/\n\n.icon-lg {\n    font-size: 1.4em;\n    line-height: 0.75em;\n    /*    vertical-align: -15%;*/\n}\n\n.icon-1-25x, .btn .icon-1-25x[class^=\"icon-\"] {\n    font-size: 1.25em;\n}\n\n.icon-1-5x, .btn .icon-1-5x[class^=\"icon-\"] {\n    font-size: 1.5em;\n}\n\n.icon-2x, .btn .icon-2x[class^=\"icon-\"] {\n    font-size: 2em;\n}\n\n.icon-2-5x, .btn .icon-2-5x[class^=\"icon-\"] {\n    font-size: 2.5em;\n}\n\n.icon-3x, .btn .icon-3x[class^=\"icon-\"] {\n    font-size: 3em;\n}\n\n.icon-rotate-270:before {\n    display: inline-block;\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n\n.icon-rotate-90:before {\n    display: inline-block;\n    -webkit-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
